import React, { useState, useEffect } from "react";
import { getMetadataUnsupportedMessage } from "../utils/metadataCapabilities";

const MetadataEditor = ({
  fileMetadata,
  onMetadataChange,
  disabled,
  writable = true,
  outputFormat = "mp3",
}) => {
  const [metadata, setMetadata] = useState(fileMetadata);

  useEffect(() => {
    setMetadata(fileMetadata);
  }, [fileMetadata]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newMetadata = {
      ...metadata,
      [name]: value,
    };
    setMetadata(newMetadata);
    onMetadataChange(newMetadata);
  };

  const fieldsDisabled = disabled || !writable;

  return (
    <div
      className={`metadata-editor${
        fieldsDisabled ? " metadata-editor--disabled-fields" : ""
      }`}
      style={{ marginTop: "20px" }}
    >
      <h3>メタデータ編集 ✍️</h3>
      {!writable && (
        <p
          style={{
            margin: "0 0 12px",
            fontSize: "0.9rem",
            color: "#666",
            textAlign: "left",
          }}
        >
          {getMetadataUnsupportedMessage(outputFormat)}
        </p>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          maxWidth: "400px",
          margin: "0 auto",
        }}
      >
        <div>
          <label
            htmlFor="cac-metadata-title"
            style={{ display: "block", marginBottom: "5px", textAlign: "left" }}
          >
            曲名
          </label>
          <input
            id="cac-metadata-title"
            type="text"
            name="title"
            value={metadata.title || ""}
            onChange={handleChange}
            disabled={fieldsDisabled}
          />
        </div>
        <div>
          <label
            htmlFor="cac-metadata-artist"
            style={{ display: "block", marginBottom: "5px", textAlign: "left" }}
          >
            アーティスト名
          </label>
          <input
            id="cac-metadata-artist"
            type="text"
            name="artist"
            value={metadata.artist || ""}
            onChange={handleChange}
            disabled={fieldsDisabled}
          />
        </div>
        <div>
          <label
            htmlFor="cac-metadata-album"
            style={{ display: "block", marginBottom: "5px", textAlign: "left" }}
          >
            アルバム名
          </label>
          <input
            id="cac-metadata-album"
            type="text"
            name="album"
            value={metadata.album || ""}
            onChange={handleChange}
            disabled={fieldsDisabled}
          />
        </div>
      </div>
    </div>
  );
};

export default MetadataEditor;
